export const PROFILE_PAGE_SLUG = "profile";
